import { Button } from '@quickmd-llc/design-system';
import { formatTimeToAmPm } from '@utils';

interface Props {
  onClick: (time: string) => void;
  times: string[];
  title: string;
}

export default function TimeSlotGrid({
  onClick,
  times,
  title,
}: Props): JSX.Element | null {
  if (!times.length) {
    return null;
  }

  return (
    <div data-testid="pw_times_grid">
      <div className="mb-2">{title}</div>
      <div className="grid grid-cols-3 gap-2">
        {times.map((time) => (
          <Button
            key={time}
            onClick={() => onClick(time)}
            priority="secondary"
            size="s"
          >
            {formatTimeToAmPm(time)}
          </Button>
        ))}
      </div>
    </div>
  );
}
